<template>
  <div class="relative">
    <md-datepicker
      v-model="mutableValue"
      :md-model-type="String"
      :md-disabled-dates="disableDate"
      :md-open-on-focus="openOnFocus"
      :md-immediately="immediately"
      :md-debounce="debounce"
      ref="datepickerRef"
    >
      <slot></slot>
    </md-datepicker>
    <div class="date-disabled" v-if="isDisable"></div>
  </div>
</template>
<script>
export default {
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    isDisable: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Object, String],
      default: () => ({})
    },
    disableDate: {
      type: [Array, Function],
      default: null
    },
    openOnFocus: {
      type: Boolean,
      default: true
    },
    immediately: {
      type: Boolean,
      default: false
    },
    debounce: {
      type: Number,
      default: 200
    }
  },
  computed: {
    mutableValue: {
      get: function() {
        return this.value;
      },
      set: function(value) {
        this.$emit("change", value);
      }
    }
  },
  mounted() {
    this.$refs.datepickerRef.$el.querySelector("input").readOnly = true;
  }
};
</script>
<style lang="scss" scoped>
.date-disabled {
  position: absolute;
  z-index: 10;
  width: 100%;
  top: 0;
  left: 0;
  height: 36px;
  cursor: not-allowed;
}
</style>
